import OContainer from "../display/OContainer";
import Omy from "../Omy";
import OMap from "../utils/OMap";

export default class ViewManager extends OContainer {
    constructor() {
        super();

        this.C_DESTROY_W = "destroyW";
        this.C_CREATE_W = "createW";
        this.C_DESTROY_P = "destroyP";
        this.C_CREATE_P = "createP";
        this.C_OPEN = "open:";
        this.C_CLOSE = "close:";
        this.C_START_OPEN = "start_open:";
        this.C_START_CLOSE = "start_close:";

        /**         * @type {OContainer}         */
        this._viewLayer1 = new OContainer();
        this.addChild(this._viewLayer1);

        /**         * @type {OContainer}         */
        this._viewLayer2 = new OContainer();
        this.addChild(this._viewLayer2);

        /**         * @type {OContainer}         */
        this._pageGuiLayer = new OContainer();
        this.addChild(this._pageGuiLayer);

        /**         * @type {OContainer}         */
        this._windowLayer = new OContainer();
        this.addChild(this._windowLayer);

        /**         * @type {OContainer}         */
        this._windowTopLayer = new OContainer();
        this.addChild(this._windowTopLayer);

        /**         * @type {OContainer}         */
        this._topGuiLayer = new OContainer();
        this.addChild(this._topGuiLayer);

        this.overlay = Omy.add.tint(0, 0x1B0703);
        this.overlay.interactive = true;

        /**         * @type {OContainer}         */
        this._topGui = null;
        /**         * @type {OContainer}         */
        this._pageGui = null;

        /**         * @type {OMap}         */
        this._viewStorage = new OMap();
    }

    addTopGui(gui) {
        if (this._topGui) {
            Omy.error("gui is exists!!");
            return;
        }

        this._topGui = gui;
        this._topGuiLayer.addChild(gui);
        gui.revive();
        gui = null;
    }

    addPageGui(gui) {
        if (this._pageGui) {
            Omy.error("gui is exists!!");
            return;
        }

        this._pageGui = gui;
        this._pageGuiLayer.addChild(gui);
        gui.revive();
        gui = null;
    }

    toTopLayer() {
        this._topGuiLayer.addChild(this.gameUI);
        this.gameUI.revive();
    }

    toBottomLayer() {
        this._pageGuiLayer.addChild(this.gameUI);
        this.gameUI.revive();
    }

    /**
     * @param {String} wName
     * @param {number} layer
     */
    showView(wName, layer = 1) {
        if (!this._viewStorage.has(wName))
            return null;

        let view = this._viewStorage.get(wName);
        let activeLayer = null;

        switch (layer) {
            case 2:
                activeLayer = this._viewLayer2;
                break;

            default:
                activeLayer = this._viewLayer1;
                break;
        }
        let contain = activeLayer.contains(view);

        for (let i = 0; i < activeLayer.numChildren; i++) {
            activeLayer.children[i].visible = false;
            // activeLayer.children[i].active = false;
        }

        if (contain)
            activeLayer.removeChild(view);
        activeLayer.addChild(view);
        if (!contain)
            view.revive();
        this.emit(this.C_CREATE_P, wName);
        activeLayer = null;
        return view;
    }

    /**
     * @param {String} wName
     * @param {number} layer
     */
    hideView(wName, layer = 1) {
        if (!this._viewStorage.has(wName))
            return null;

        let view = this._viewStorage.get(wName);
        let activeLayer = null;
        switch (layer) {
            case 2:
                activeLayer = this._viewLayer2;
                break;

            default:
                activeLayer = this._viewLayer1;
                break;
        }

        this.emit(this.C_DESTROY_P, wName);
        activeLayer.removeChild(view);
        view.kill();

        for (let i = 0; i < activeLayer.numChildren; i++) {
            if (!activeLayer.children[i].visible) {
                activeLayer.children[i].visible = true;
                // activeLayer.children[i].active = true;
            }
        }

        return view;
    }

    /**
     * @param {String} wName
     * @param {Boolean} removeOther
     * @param {OContainer} customLayer
     */
    showWindowTop(wName, removeOther = false, customLayer = null) {
        if (!this._viewStorage.has(wName))
            return null;
        this.addChild(this.overlay);
        this.emit(this.C_START_OPEN + wName, wName);
        return this._showWindow(customLayer || this._windowTopLayer, this._viewStorage.get(wName), removeOther);
    }

    /**
     * @param {String} wName
     * @param {Boolean} removeOther
     * @param {OContainer} customLayer
     */
    showWindow(wName, removeOther = false, customLayer = null) {
        if (!this._viewStorage.has(wName))
            return null;
        this.addChild(this.overlay);
        this.emit(this.C_START_OPEN + wName, wName);
        return this._showWindow(customLayer || this._windowLayer, this._viewStorage.get(wName), removeOther);
    }

    /**
     * clear custom layer
     * @param {OContainer}customLayer default _windowLayer
     */
    clearWindowsInLayer(customLayer) {
        customLayer = customLayer || this._windowLayer;
        while (customLayer.numChildren) {
            customLayer.removeChild(customLayer.children[0]).kill();
        }
    }

    /**
     * @param {OContainer} activeWLayer
     * @param {OContainer} view
     * @param {Boolean} removeOther
     */
    _showWindow(activeWLayer, view, removeOther = false) {
        if (removeOther) {
            while (activeWLayer.numChildren) {
                activeWLayer.removeChild(activeWLayer.children[0]).kill();
            }
        }

        for (let i = 0; i < activeWLayer.numChildren; i++) {
            if (activeWLayer.children[i].hasOwnProperty("onActiveWindow"))
                activeWLayer.children[i].onActiveWindow(false);
        }

        let contain = activeWLayer.contains(view);
        if (contain)
            activeWLayer.removeChild(view);
        activeWLayer.addChild(view);
        if (!contain)
            view.revive(this._onShowWindow.bind(this));

        return view;
    }

    _onShowWindow(wName) {
        this.overlay.parent && this.removeChild(this.overlay);
        this.emit(this.C_CREATE_W, wName);
        this.emit(this.C_OPEN + wName);
    }

    /**
     * @param {String} wName
     */
    hideWindow(wName) {
        if (!this._viewStorage.has(wName))
            return null;

        this.addChild(this.overlay);

        this.emit(this.C_START_CLOSE + wName, wName);
        let view = this._viewStorage.get(wName);
        view.kill(this._onHideWindow.bind(this));

        return view;
    }

    _onHideWindow(wName) {
        const activeWLayer = this._viewStorage.get(wName).parent;
        if (activeWLayer) {
            activeWLayer.removeChild(this._viewStorage.get(wName));
        }

        this.overlay.parent && this.removeChild(this.overlay);
        this.emit(this.C_DESTROY_W, wName);
        this.emit(this.C_CLOSE + wName);
    }

    update() {
        super.update();
        /*if(this.layoutDirty) {
            this.layoutNode.calculateLayout();
            this.applyLayout();
        }*/
    }

    getView(wName) {
        if (!this._viewStorage.has(wName))
            return null;
        return this._viewStorage.get(wName);
    }

    isViewExist(wName) {
        return this._viewStorage.has(wName);
    }

    /**
     * @param {OContainer} view
     * @param {string} wName
     */
    regWO(view, wName) {
        if (!this._viewStorage.has(wName))
            this._viewStorage.set(wName, view);
    }

    //-------------------------------------------------------------------------
    // EVENTS
    //-------------------------------------------------------------------------

    /**
     * Add event listener for opening of target window
     * @param {string} name
     * @param {Function} fn
     * @param {*} context
     * @param {boolean} once
     */
    addOpenWindow(name, fn, context = null, once = false) {
        if (once)
            this.once(this.C_OPEN + name, fn, context);
        else
            this.on(this.C_OPEN + name, fn, context);
    }

    /**
     * Remove event listener for opening of target window
     * @param {string} name
     * @param {Function} fn
     * @param {*} context
     */
    removeOpenWindow(name, fn, context = null) {
        this.removeListener(this.C_OPEN + name, fn, context);
    }

    /**
     * Add event listener for closing of target window
     * @param {string} name
     * @param {Function} fn
     * @param {*} context
     * @param {boolean} once
     */
    addCloseWindow(name, fn, context = null, once = false) {
        if (once)
            this.once(this.C_CLOSE + name, fn, context);
        else
            this.on(this.C_CLOSE + name, fn, context);
    }

    /**
     * Remove event listener for closing of target window
     * @param {string} name
     * @param {Function} fn
     * @param {*} context
     */
    removeCloseWindow(name, fn, context = null) {
        this.removeListener(this.C_CLOSE + name, fn, context);
    }

    /**
     * Add event listener for start opening of target window
     * @param {string} name
     * @param {Function} fn
     * @param {*} context
     * @param {boolean} once
     */
    addStartOpenWindow(name, fn, context = null, once = false) {
        if (once) this.once(this.C_START_OPEN + name, fn, context);
        else this.on(this.C_START_OPEN + name, fn, context);
    }

    /**
     * Remove event listener for start opening of target window
     * @param {string} name
     * @param {Function} fn
     * @param {*} context
     */
    removeStartOpenWindow(name, fn, context = null) {
        this.removeListener(this.C_START_OPEN + name, fn, context);
    }

    /**
     * Add event listener for start closing of target window
     * @param {string} name
     * @param {Function} fn
     * @param {*} context
     * @param {boolean} once
     */
    addStartCloseWindow(name, fn, context = null, once = false) {
        if (once) this.once(this.C_START_CLOSE + name, fn, context);
        else this.on(this.C_START_CLOSE + name, fn, context);
    }

    /**
     * Remove event listener for start closing of target window
     * @param {string} name
     * @param {Function} fn
     * @param {*} context
     */
    removeStartCloseWindow(name, fn, context = null) {
        this.removeListener(this.C_START_CLOSE + name, fn, context);
    }

    addDestroyWindow(func, context, once = false) {
        if (once)
            this.once(this.C_DESTROY_W, func, context);
        else
            this.on(this.C_DESTROY_W, func, context);
    }

    removeDestroyWindow(func, context) {
        this.removeListener(this.C_DESTROY_W, func, context);
    }

    addCreateWindow(func, context, once = false) {
        if (once)
            this.once(this.C_CREATE_W, func, context);
        else
            this.on(this.C_CREATE_W, func, context);
    }

    removeCreateWindow(func, context) {
        this.removeListener(this.C_CREATE_W, func, context);
    }

    addDestroyView(func, context, once = false) {
        if (once)
            this.once(this.C_DESTROY_P, func, context);
        else
            this.on(this.C_DESTROY_P, func, context);
    }

    removeDestroyView(func, context) {
        this.removeListener(this.C_DESTROY_P, func, context);
    }

    addCreateView(func, context, once = false) {
        if (once)
            this.once(this.C_CREATE_P, func, context);
        else
            this.on(this.C_CREATE_P, func, context);
    }

    removeCreateView(func, context) {
        this.removeListener(this.C_CREATE_P, func, context);
    }

    //-------------------------------------------------------------------------
    // ACCESSOR
    //-------------------------------------------------------------------------

    get topGui() {
        return this._topGui || this._pageGui;
    }

    get pageGui() {
        return this._pageGui || this._topGui;
    }

    get gameUI() {
        return this._pageGui || this._topGui;
    }
}
